export function hideCommonRow()
{
    $('.result-stack-logo').addClass('hidden');
    $('.progressbar, .progress').hide();
    $("#modal-header-contact,#schedulermodallabel").addClass("hidden");
}